import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
const { default: Auth } = require("../../../services/Auth/Auth");
const { useState, useEffect } = require("react");

const AuthVerify = () => {
  const navigate = useNavigate();
  const interval = useRef();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    interval.current = setInterval(() => {
      let user = Auth.getCurrentUser();
      if (!user) return;
      let tokenIsExpired = Auth.tokenIsExpired();
      if (tokenIsExpired) {
        setIsOpen(true);
        Auth.logout();
        clearInterval(interval.current);
      }
    }, 1000);
    return () => clearInterval(interval.current);
  }, []);

  return (
    <div>
      <Dialog open={isOpen} onClose={() => {}}>
        <DialogTitle>Session habis!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Session anda sudah habis! Harap masuk (login) kembali untuk
            melanjutkan menggunakan SISIDANG.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setIsOpen(false);
              navigate("/masuk", { replace: true });
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default AuthVerify;
